import React, { useRef, useState } from 'react';
import TextField from '@mui/material/TextField';
import { FormikErrors } from 'formik';
import { useTranslation } from 'react-i18next';

interface Props {
  inputProps: any;
  onChange: any;
  onBlur: any;
  helperText: string | string[] | FormikErrors<any> | FormikErrors<any>[];
  error: boolean;
}

function PhoneField(props: Props) {
  const { t } = useTranslation();
  const ref = useRef<HTMLInputElement>();
  const [phone, setPhone] = useState<string>(props.inputProps.defaultValue);

  // Guarantee that there's 1 and only 1 + at the beginning of the phone number
  const handleUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const value = ref.current?.querySelector('input')?.value;
    const key = event.key;
    if (key && value) {
      if (value.length >= 1) {
        let result;
        if (value === '0') {
          result = '+';
        } else if (value[0] !== '+') {
          result = '+' + value;
        }
        if (result) {
          setPhone(result);
          props.onChange(result);
          event.preventDefault();
        }
      }
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setPhone(value);
    props.onChange(event);
  };

  const { defaultValue, ...rest } = props.inputProps;
  return (
    <TextField
      color={'info'}
      error={props.error}
      autoFocus={true}
      value={phone}
      onKeyUp={handleUp}
      onChange={handleChange}
      onBlur={props.onBlur}
      fullWidth={true}
      role={'input'}
      label={t('phone')}
      variant="standard"
      margin={'dense'}
      helperText={props.helperText}
      InputLabelProps={{ shrink: true, error: false }}
      InputProps={{
        placeholder: '+1',
        type: 'phone',
        ref: ref,
        ...rest,
      }}
    />
  );
}

export default PhoneField;
